export default __webpack_public_path__ + "static/media/msanp-brand.2a9e76c1.svg";